import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contexts-new-context',
  templateUrl: './contexts-new-context.component.html',
  styleUrls: ['./contexts-new-context.component.scss']
})
export class ContextsNewContextComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
